module.exports = __webpack_public_path__ + "static/media/slash.0eb82d26.svg";